import { render } from "./myInq.vue?vue&type=template&id=52160d92&scoped=true"
import script from "./myInq.vue?vue&type=script&lang=js"
export * from "./myInq.vue?vue&type=script&lang=js"

import "./myInq.vue?vue&type=style&index=0&id=52160d92&lang=scss"
import "./myInq.vue?vue&type=style&index=1&id=52160d92&lang=scss&scoped=true"

import exportComponent from "/Users/a/Desktop/app/pulizhenkong_pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52160d92"]])

export default __exports__